import React from 'react';
import {Link} from "react-router-dom";
import '../../../styles/tutorial archive/Themes.css';

// Images
const IntroImages = {
    henry: require("../../../Assets/Tutorials/Themes Tutorial/Page 1 - Setup + Metadata/Henry.png"),
    metadatafile: require("../../../Assets/Tutorials/Themes Tutorial/Page 1 - Setup + Metadata/metadata file.png"),
    cover: require("../../../Assets/Tutorials/Themes Tutorial/Page 1 - Setup + Metadata/Cover.png")

};

export default function themeTutorial() {
    return (
        <div className="about-frame">
            <div id="about">
                <p>HOW TO MAKE A CUSTOM THEME</p>
            </div>
            <span className="normal-text">
                    This is one of the best ways to make Poly Beats FEEL like your own creation.
                <br></br>
                Does this sound good to you? Then let's get started!
            <br></br><br></br>
            This guide works for Windows computers at the moment.</span>
            <div className="about-leftalign">
                <br></br>
                <br></br>
                <div className="about-leftalign">
                    <p><br/><br/>TABLE OF CONTENTS</p>

                    {/* Table of Contents */}
                    <ul className="toc">
                        <li><a href="#skip-this">Skip This: If You're Lazy</a></li>
                        <li><a href="#setting-up-a-directory">1. Setting Up A Directory</a></li>
                        <li><a href="#metadata.info">2: Metadata.info (file)</a></li>
                        <li><a href="#next-section">Next Section: Menu.polybeatsconfig</a></li>
                    </ul>
                </div>

                {/* Sections to jump to */}
                <div id="skip-this" className="sectionFormatting">
                    <h2>Skip This: If You're Lazy</h2>
                    <div id="setting-up-a-directory" className="sectionFormatting">
                        <p>If you want to skip this section of this tutorial, you can go to the archive below, and get
                            the .zip file that starts with the name [CURRENT], which means its the latest supported
                            Theme schema, and extract its contents into this folder:
                            <br></br>
                            <code>"%appdata%/../LocalLow/5th Step Games/Poly Beats/Local Themes"</code>
                        </p>
                        <Link to="https://drive.google.com/drive/u/0/folders/1COihgiDfKcQ2vbO1vBNGjiGWqj3UqNVM">
                            <button className="fof-menu-button"><span>DOWNLOAD TEMPLATE</span></button>
                        </Link>

                    </div>
                </div>


                <div id="metadata.info" className="sectionFormatting">
                    <br></br>
                    <div id="setting-up-a-directory" className="sectionFormatting">
                        <p>Before we get started, if you are planning to upload your theme to the Poly Beats Marketplace
                            (our Steam Workshop), please look at our End User License Agreement to make sure your Theme
                            is
                            in accordance with it.
                            <br></br>
                            <br></br>
                            Not adhering to this guideline can get your content removed from the Marketplace, and get
                            you
                            banned from there! And that's no fun. Is it? </p>
                        <h2>1. Setting Up A Directory</h2>
                        <p>Themes that are being made by you NEED to be in the <u>Persistent Data Path</u>. To get
                            there, all you need to do is copy paste this path to your machine: </p>
                        <code>"%appdata%/../LocalLow/5th Step Games/Poly Beats/Local Themes"</code>
                        <p>And all we need to do in here is create a new folder - and I'm gonna name this one Henry,
                            just to keep this guide simple. Say hi to henry :)</p>
                        <div className="leftright-textimage-align">
                            <img
                                src={IntroImages.henry}
                                style={{height: "120px", width: "120px"}}
                                alt="Henry!"
                            />
                            <div>
                                <h3>"What's This For?"</h3>
                                <p>This is basically where all the files for our theme goes. This is where you'll be
                                    spending most of your time... so make yourself comfortable with your Henry!</p>
                            </div>
                        </div>

                    </div>
                    <h2>2. Metadata.info (file)</h2>
                    <p>This section is where most of the information is, about your theme. This should be very simple to
                        understand, and players will see most of the things in this section.
                        <br></br>When you open the file (in a text editor or IDE), it will look a bit like this:</p>

                    <img
                        src={IntroImages.metadatafile}
                        style={{height: "263.25px", width: "1080px"}}
                        alt="Metadata.info format 2. 'Jetbrains Mono' font. Captured with CodeSnap™."
                    />

                    <h3>Metadata - Data Reference</h3>
                    <p>
                        "Name" - The name of your font.
                        <br/><br></br>
                        "Creators" - Who made this font? If it more than one person, you can leave a comma between
                        names, or put an "//" between two names to look cooler.
                        <br/><br></br>
                        "ShortDescription" - This should be a super quick one-liner statement about your font. You can
                        leave this blank if you want, but it's recommended to just do a short thing. Even if it's a
                        super bad joke. It works.
                        <br/><br></br>
                        "LongDescription" - This is a longer description of your font, which can be shown in the Steam
                        Workshop, and alongside the in-game downloader you can get access to by becoming a monthly
                        HarmonyFunder (donator) of our game :)
                        <br/><br></br>
                        "CoverPath" - Where the Cover Art to your theme is, relative to the Theme's folder.</p>

                    <div className="leftright-textimage-align">
                        <img
                            src={IntroImages.cover}
                            style={{height: "175px", width: "175px"}}
                            alt="Henry!"
                        />
                        <div>
                            <h3>"Cover Art"(.png)</h3>
                            <p> This is an image that's shown alongside your theme in the selector, and is also shown on
                                the Marketplace.
                                <br></br>
                                <span className = "dimensionsText"> Dimensions: 800px x 800px </span> - any more can cause lag when loading for lower-end players, and use more RAM in the player's computer. </p>
                        </div>
                    </div>
                    <p>
                        "Version" - The current version of the font. This is so players can check if they have the latest version on their machine or not :)
                </p>
                </div>


                <div id="next-section" className="sectionFormatting">
                    <h2>Next Section: Menu.polybeatsconfig</h2>
                    <p>
                        This is the most important part of designing a game, therefore it's the most important part of
                        designing a theme!
                        <br/><br></br>
                        It's a detailed outline of all the variables and properties you can change in
                        menus, to make Poly Beats truly yours.
                        Making Themes can take a while, so don't be discouraged if it takes longer than you expected. I
                        know you're working on something great! &lt;3
                    </p>

                    <Link to="/Tutorial-Archive/Themes/Menu.polybeatsconfig">
                        <button className="fof-menu-button"><span>Menu.polybeatsconfig -></span></button>
                    </Link>
                </div>
            </div>
        </div>
    );
}